import { render, staticRenderFns } from "./pages-side.vue?vue&type=template&id=32284774"
import script from "./pages-side.vue?vue&type=script&lang=js"
export * from "./pages-side.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports